module.exports = __webpack_public_path__ + "img/cancel.1d955780.svg";